import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabase";

export default function useAuthorBooks(activeTab, book) {
  const [authorBooks, setAuthorBooks] = useState([]);
  const [authorBooksLoading, setAuthorBooksLoading] = useState(false);
  const authorCacheRef = useRef({});

  useEffect(() => {
    if (activeTab !== "author" || !book) return;
    const author = book.author;
    if (authorCacheRef.current[author]) {
      setAuthorBooks(authorCacheRef.current[author].filter(d => d.title !== book.title));
      return;
    }
    let cancelled = false;
    async function loadAuthorBooks() {
      setAuthorBooksLoading(true);
      // authorCache 문서 -> author_cache 테이블 (작가명이 곧 기본키라 id 가공이 불필요해졌다)
      try {
        const { data: cached } = await supabase
          .from("author_cache")
          .select("books")
          .eq("author", author)
          .maybeSingle();
        if (cached?.books?.length > 0) {
          authorCacheRef.current[author] = cached.books;
          if (!cancelled) {
            setAuthorBooks(cached.books.filter(d => d.title !== book.title));
            setAuthorBooksLoading(false);
          }
          return;
        }
      } catch {}
      try {
        const { data, error } = await supabase.functions.invoke("search-books", { body: { q: author } });
        if (!error && !cancelled) {
          const results = (data?.documents || []).map(d => ({
            id: d.isbn || d.url,
            title: d.title,
            author: (d.authors || []).join(", "),
            cover: d.thumbnail || null,
            publishedDate: d.datetime ? d.datetime.slice(0, 4) : "",
            isExternal: true,
          }));
          if (results.length > 0) {
            authorCacheRef.current[author] = results;
            try {
              await supabase
                .from("author_cache")
                .upsert({ author, books: results, cached_at: new Date().toISOString() }, { onConflict: "author" });
            } catch {}
          }
          setAuthorBooks(results.filter(d => d.title !== book.title));
        }
      } catch {}
      if (!cancelled) setAuthorBooksLoading(false);
    }
    loadAuthorBooks();
    return () => { cancelled = true; };
  }, [activeTab, book]);

  return { authorBooks, authorBooksLoading };
}
